
import 'firebase/compat/auth';
import { initializeApp } from "firebase/app"
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  GoogleAuthProvider, signInWithPopup, sendEmailVerification, signOut, FacebookAuthProvider, linkWithCredential, EmailAuthProvider
} from "firebase/auth";
import {
  doc, setDoc, updateDoc, where, collection, query, getDoc,
  enableIndexedDbPersistence, initializeFirestore, CACHE_SIZE_UNLIMITED, orderBy, increment, arrayUnion, arrayRemove,
} from "firebase/firestore";

import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";


export const database = initializeApp(

  {

    apiKey: "AIzaSyDGOw3hF-nB8-y3L_5uRXA3bg3Z1wmriVM",
    authDomain: "bookas-baliwag-library.firebaseapp.com",
    projectId: "bookas-baliwag-library",
    storageBucket: "bookas-baliwag-library.appspot.com",
    messagingSenderId: "54673278045",
    appId: "1:54673278045:web:fefaa85e7ec5f2738079b4",
    measurementId: "G-6LH3BDPQ31"


  }
  /*{
    apiKey: "AIzaSyChHXbak-BBNP_PPo-piYEQHF711ydupoU",
    authDomain: "bookas-temp.firebaseapp.com",
    projectId: "bookas-temp",
    storageBucket: "bookas-temp.appspot.com",
    messagingSenderId: "957934525801",
    appId: "1:957934525801:web:9e7306e3b684e4612e31f8",
    measurementId: "G-6KDW0KC60R"

  }*/
);

/*export const database = initializeApp(
  {
    apiKey: "AIzaSyDc0goTl7lpotJ0Qy2cqqDo5w8CbzYyryw",
    authDomain: "klasiko-9cd45.firebaseapp.com",
    projectId: "klasiko-9cd45",
    storageBucket: "klasiko-9cd45.appspot.com",
    messagingSenderId: "324176653768",
    appId: "1:324176653768:web:74178c2ab56943491aa4fd",
    measurementId: "G-PJYB41Q0EZ" 
  }
);*/

const auth = getAuth();
const storage = getStorage();
//const db = getFirestore(database);
const db = initializeFirestore(database, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
});
//get document

export const user = getAuth(database);
export const getAuthorize = getAuth();
export const uploadTask = uploadBytesResumable;

const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
const charactersLength = characters.length;

enableIndexedDbPersistence(db)
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

export function signUser(email, password) {
  let state = true;
  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      alert("User is successfully signed in.");
    }).catch((error) => {
      const errorMessage = error.message;
      console.log(error)
      alert(errorMessage);
      state = false;
    });
  return state;
}

export function googleSignin() {
  const provider = new GoogleAuthProvider();
  signInWithPopup(auth, provider)
    .then((result) => {
      const credential = EmailAuthProvider.credential(result.user.email, result.user.uid)
      linkWithCredential(auth.currentUser, credential).then((userCredential) => {
        if (userCredential) {
          return result.user;
        }
      }).catch((error) => {
        return ""
      })
      // ...
    }).catch((error) => {
      return "";
      // ...
    });
  return ""
}

export function facebookSignin() {
  const provider = new FacebookAuthProvider();
  signInWithPopup(auth, provider)
    .then((result) => {
      return result.user;
      // ...
    }).catch((error) => {
      return "";
      // ...
    });

}


export function verifyEmail() {
  sendEmailVerification(auth.currentUser)
    .then(() => {
      return true;
    });
  return false;
}

export function registerUser(provider, userFirstName, userLastName, userAddress, userEmail, userContact, userPass) {
  let state = true;
  if (provider === "email") {
    createUserWithEmailAndPassword(auth, userEmail, userPass)
      .then((userCredential) => {
        // Signed in 
        setDoc(doc(db, "users", userCredential.user.uid), {
          userID: userCredential.user.uid,
          userFirstName: userFirstName,
          userLastName: userLastName,
          userAddress: userAddress,
          userEmail: userEmail,
          userContact: userContact,
          userPass: userPass,
          bookmarks: [],
          borrowedBooks: [],
          reservedBooks: [],
          borrowerCard: "",
          libraryNumber: ""
        });
        // ...
      })
      .catch((error) => {
        const errorMessage = error.message;
        alert(errorMessage);
        state = false;
        // ..
      });
  }
  return state;
}

export function registerProfile(name, birthday, address, gender, role, image) {
  setDoc(doc(db, "users", auth.currentUser.uid), {
    uid: auth.currentUser.uid,
    email: auth.currentUser.email,
    name: name,
    birthday: birthday,
    address: address,
    gender: gender,
    role: role,
    sectionJoined: [],
    courseJoined: []
  });
  uploadAvatar(image);
  // ...
  return true;
}

export async function updateProfile(userObject) {
  var currentUser = auth.currentUser.uid
  var updated = await updateDoc(doc(db, "users", currentUser), userObject)
  return updated;
}

async function uploadAvatar(image) {
  let storageRef = ref(storage, 'images/' + user.currentUser.uid);
  uploadBytes(storageRef, image).then((snapshot) => {
    getDownloadURL(storageRef).then((url) => {
      updateDoc(doc(db, "users", user.currentUser.uid), {
        avatarProfile: url
      });
    })
  })
}

export function signoutUser() {
  return signOut(auth);
}


export async function getDocument(userID) {
  if (userID) {
    return await getDoc(doc(db, "users", userID));
  }
  return "";
}

export function checkUser(email) {
  return (query(collection(db, "users"), where("email", "==", email)));
}

export async function editProfile(userFN, userLN, userAdd, userEmail, userContact) {
  var user = auth.currentUser.uid
  var added = setDoc(doc(db, "users", user), {
    userID: user,
    userFirstName: userFN,
    userLastName: userLN,
    userAddress: userAdd,
    userEmail: userEmail,
    userContact: userContact,
    userPass: user,
    bookmarks: [],
    borrowedBooks: [],
    reservedBooks: [],

  })
  return added
}

//books 

export function getBooks() {
  return query(collection(db, "books"), orderBy("bookTitle"));
}

export function getSomeBooks(bookArray) {
  return query(collection(db, "books"), where("bookID", 'in', bookArray));
}

export async function addViews(bookID) {
  await updateDoc(doc(db, "books", bookID), {
    bookViews: increment(1)
  });
}

export async function addBookmark(bookID) {
  var user = auth.currentUser.uid
  await updateDoc(doc(db, "users", user), {
    bookmarks: arrayUnion(bookID)
  })
}

export async function removeBookmark(bookID) {
  var user = auth.currentUser.uid
  await updateDoc(doc(db, "users", user), {
    bookmarks: arrayRemove(bookID)
  })
}

export async function getBookmarks() {
  var user = auth.currentUser ? auth.currentUser.uid : false
  if (user) return await getDoc(doc(db, "users", user));
}

//collections

export function getCollections() {
  return query(collection(db, "collections"), orderBy("collectionTitle"));
}


//categories

export function getCategories() {
  return query(collection(db, "categories"), orderBy("categoryTitle"));
}

//ebooks
export function getEbooks() {
  return query(collection(db, "ebooks"), orderBy("ebookTitle"));
}


export async function addDownloads(ebookID) {
  await updateDoc(doc(db, "ebooks", ebookID), {
    ebookDownloads: increment(1)
  });
}

//requests

export async function addRequest(bookID, dateReserved, duration) {
  var userID = auth.currentUser.uid
  var result = ""
  for (var i = 0; i < 6; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    if (i === 5) {
      var temp = await checkRequest(result);
      if (temp.data()) {
        i = -1;
        result = "";
      }
    }
  }
  var added = await setDoc(doc(db, "requests", result), {
    requestID: result,
    borrowerID: userID,
    bookBorrowed: bookID,
    dateRequested: new Date().toISOString(),
    dateReserved: dateReserved,
    duration: duration,
    status: "Pending"
  })
  await updateDoc(doc(db, "users", userID), {
    reservedBooks: arrayUnion(bookID)
  })
  return added;
}

async function checkRequest(requestID) {
  return await getDoc(doc(db, "courses", requestID));
}

export function getRequests() {
  var userID = auth.currentUser.uid
  return query(collection(db, "requests"), where("borrowerID", '==', userID), orderBy("dateRequested"));
}

export function getBookmarkedBook() {
  return query(collection(db, "books"));
}

//transactions
export function getTransactions() {
  var userID = auth.currentUser.uid
  var borrowed = ["borrowed", "Borrowed", "BORROWED"]

  return query(collection(db, "transactions"),
    where("borrowerID", '==', userID),
    where("status", 'in', borrowed),
    orderBy("dateBorrowed")
  );
}

//notifications
export function getNotifications() {
  var userID = auth.currentUser.uid
  return query(collection(db, "users", userID, "notifications"), orderBy("notifTime"));
}

export function getReturnedTransactions() {
  var userID = auth.currentUser.uid
  var returned = ["returned", "Returned", "RETURNED"]

  return query(collection(db, "transactions"), where("borrowerID", '==', userID), where("status", 'in', returned), orderBy("dateReturned"));

}

export function getPenaltyTransactions() {
  var userID = auth.currentUser.uid
  var returned = ["returned", "Returned", "RETURNED"]

  return query(collection(db, "transactions"),
    where("borrowerID", '==', userID),
    where("status", 'in', returned),
    where("withPenalty", '==', true),
    orderBy("dateReturned")
  );

}